export const initCheckoutStore = (data) => {
  window.App.store.registerModule('checkout', {
    namespaced: true,
    state: data,
    mutations: {
      setData(state, data) {
        state = {...state, ...data};
      },
      setShippingData(state, shipping) {
        state.shipping = shipping;
        state.shipping = shipping;
      },
      setPaymentData(state, payment) {
        state.payment = payment;
      },
    },
  });
};

window.App.initCheckoutStore = initCheckoutStore;



// WEBPACK FOOTER //
// ./public/themes/frontend/uikit3/extensions/rubinred/ecommerce/assets/js/CheckoutStoreModule.js